import { memo } from "react";
import { Modal, Accordion } from "react-bootstrap";
import Axe from "../../../assets/images/sidebar/icons/axeMark.svg";
import down_arrow from '../../../assets/images/downArrow2.svg';

const DisplayTask = memo((props) => {

    const { displayTask, handleCloseDisplay, taskDetails, setDisplayTask } = props


    return (
        <>
            <Modal
                size="xl"
                show={displayTask}
                aria-labelledby="modal-90w"
                onHide={() => setDisplayTask(false)}
                className="add-task-modal-main"
                centered
            >
                <Modal.Header className="add-task-modal-header">
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Task Details
                    </Modal.Title>

                    <div className="rightAxe">
                        <img src={Axe} alt="close"
                            onClick={() => setDisplayTask(false)}
                        />
                    </div>
                </Modal.Header>

                <Modal.Body>
                    <div className='row'>
                        <div className="col-md-12">
                            <h6>Name : {taskDetails?.title}</h6>
                        </div>
                        <div className="col-md-4">
                            <h6>Story Point : {taskDetails?.storyPointsSuggested}</h6>
                        </div>
                        <div className="col-md-4">
                            <h6>Budget Hour : {taskDetails?.budgetHoursTotal}</h6>
                        </div>
                        {/* <div className='col-md-12'>
                            {
                                taskDetails?.acceptanceCriteria?.map((accept) => {
                                    <li>{accept}</li>
                                })
                            }
                        </div> */}
                        <div style={{
                            height: "60vh",
                            overflowY: "scroll",
                            scrollbarWidth: "none",
                            msOverflowStyle: "none"
                        }}>
                            <Accordion defaultActiveKey="0">
                                {
                                    taskDetails?.technicalBreakdown?.map((task, index) => {
                                        return <Accordion.Item eventKey={index} className="mt-2">
                                            <Accordion.Header>
                                                <div
                                                    className="menus-items w-100 d-flex justify-content-between"
                                                    style={{
                                                        backgroundColor: "whiteSmoke",
                                                        padding: "15px",
                                                    }}
                                                >
                                                    <div className="d-flex gap-1">
                                                        <h5>{task?.stepId}</h5>
                                                        <img src={down_arrow} height={24} alt="down arrow"

                                                        />
                                                    </div>

                                                </div>
                                            </Accordion.Header>

                                            <Accordion.Body>
                                                <div className="p-4">
                                                    <div className="row create-workflow-topbody pb-4">
                                                        <div className="col-lg-12 row">
                                                            <div className="col-lg-12">
                                                                <label className="text-grey">Task Name :</label>
                                                                <h6>{task?.task}</h6>
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-4 mt-3">
                                                            <label className="text-grey">Hours</label>
                                                            <h6>{task?.hours}</h6>
                                                        </div>

                                                        <div className="col-lg-4 mt-3">
                                                            <label className="text-grey">Assigned Roles</label>
                                                            <h6>{task?.assignedRole}</h6>
                                                        </div>

                                                        <div className="col-lg-4 mt-3">
                                                            <label className="text-grey">Complexity</label>
                                                            <h6>{task?.complexityLevel}</h6>
                                                        </div>
                                                        <div className="col-lg-12 mt-2">

                                                            {
                                                                task?.activities?.map((i, index) => {
                                                                    return <li>{i}</li>
                                                                })
                                                            }


                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    })
                                }


                            </Accordion>
                        </div>
                    </div>
                </Modal.Body >


            </Modal >

        </>
    )

})

export default DisplayTask